import React from 'react';

import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  View,
  makeStyles,
} from '@gogame/components';
import { DateValueFormatter } from '@gogame/intl-ts';

const useStyles = makeStyles({
  container: {
    maxHeight: '100%',
  },
});

const ActionsLog = ({ logs, isFetching, isLoading, onRowsScrollEnd }) => {
  const classes = useStyles(logs.length || 0);

  return (
    <View fetching={isFetching} loading={isLoading}>
      {logs && logs.length ? (
        <TableContainer className={classes.container}>
          <Table stickyHeader={true}>
            <TableHead>
              <TableRow>
                <TableCell col={'dateTime'} width={150}>
                  Date / Time
                </TableCell>
                <TableCell col={'changeBy'} width={150}>
                  Change by
                </TableCell>
                <TableCell col={'actions'} width={130}>
                  Actions
                </TableCell>
                <TableCell col={'entity'} width={130}>
                  Entity
                </TableCell>
                <TableCell col={'details'}>Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody onRowsScrollEnd={onRowsScrollEnd}>
              {logs.map((action, i) => (
                <TableRow key={i}>
                  <TableCell col={'dateTime'}>
                    <DateValueFormatter
                      value={action.date}
                      template={'LLL'}
                      timeZone={'local'}
                    />
                  </TableCell>
                  <TableCell col={'changeBy'}>
                    {action.user && action.user.name}
                  </TableCell>
                  <TableCell col={'actions'}>
                    {action.type ? (
                      <Typography
                        size={'13px'}
                        type={action.type.id === 6 ? 'error' : undefined}
                      >
                        {action.type.name}
                      </Typography>
                    ) : null}
                  </TableCell>
                  <TableCell col={'actions'}>
                    {action.entityType && action.entityType.name}
                  </TableCell>
                  <TableCell col={'details'} style={{ wordBreak: 'break-all' }}>
                    {action.message}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}
    </View>
  );
};

export default ActionsLog;
